import EditModals from "admin-panel/reservation/Modals";
import { BsPencilSquare, BsEye } from "react-icons/bs";
import ReactDOM from "react-dom";

export default function Card({ index, type }) {
  // types : reserve - order
  return (
    <>
      <div
        className={`card-item-tabs d-flex flex-wrap ${
          index % 2 !== 0 && "is-dark-blue"
        }`}
      >
        <div>
          <div className="title">عنوان تور</div>
          <div className="description">کیش</div>
        </div>
        <div>
          <div className="title">نام خریدار</div>
          <div className="description">علی احمدی</div>
        </div>
        <div>
          <div className="title">تعداد ثبت نامی</div>
          <div className="description">6</div>
        </div>
        <div>
          <div className="title">قیمت واحد</div>
          <div className="description">100,000</div>
        </div>
        <div>
          <div className="title">قیمت کل</div>
          <div className="description">600,000</div>
        </div>
        <div>
          <div className="title">مبلغ تور</div>
          <div className="description"> 100,000 تومان</div>
        </div>
        <div>
          <div className="title">تاریخ</div>
          <div className="description">1400/1/2</div>
        </div>
        <div>
          <div className="title">مبلغ پرداخت شده</div>
          <div className="description">50/000 تومان</div>
        </div>
        <div>
          <div className="title">مانده حساب</div>
          <div className="description">50,000 تومان</div>
        </div>
        <div>
          <div className="title">ترنسفر تا مبدا حرکت</div>
          <div className="description">100,000 تومان</div>
        </div>
        <div>
          <div className="title">لیدر تخصصی</div>
          <div className="description">40,000 تومان</div>
        </div>
        <div>
          <div className="title">عملیات</div>
          {type == "reserve" && (
            <div className="description" style={{ cursor: "pointer" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33.015"
                height="20.985"
                viewBox="0 0 33.015 32.985"
              >
                <g
                  id="Icon_feather-link"
                  data-name="Icon feather-link"
                  transform="translate(-1.493 -1.508)"
                >
                  <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M15,19.5a7.5,7.5,0,0,0,11.31.81l4.5-4.5A7.5,7.5,0,1,0,20.2,5.2L17.625,7.77"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                  />
                  <path
                    id="Path_190"
                    data-name="Path 190"
                    d="M21,16.5a7.5,7.5,0,0,0-11.31-.81l-4.5,4.5A7.5,7.5,0,1,0,15.8,30.8L18.36,28.23"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                  />
                </g>
              </svg>
              <BsPencilSquare
                data-bs-toggle="modal"
                data-bs-target="#edit-tour"
                style={{ fontSize: "20px", marginRight: "10px" }}
              ></BsPencilSquare>
            </div>
          )}
          {type == "order" && (
            <div className="description" style={{ cursor: "pointer" }}>
              <BsEye
                data-bs-toggle="modal"
                data-bs-target="#edit-tour"
                style={{ fontSize: "20px", marginRight: "10px" }}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
